module.exports = "<div class=\"alert {{ $ctrl.messageService.alerttype }}\" ng-show=$ctrl.messageService.show> <icon class=\"alert__icon alert__icon--success\" ng-if=\"$ctrl.messageService.alerttype === 'alert--success'\" icon=tick></icon> <icon class=\"alert__icon alert__icon--failure\" ng-if=\"$ctrl.messageService.alerttype === 'alert--fail'\" icon=cross></icon> <p class=alert__message ng-repeat=\"message in $ctrl.messageService.messages\">{{message}}</p> </div>";


//////////////////
// WEBPACK FOOTER
// ./frontend/storefront/app/modules/page/views/message.html
// module id = 725
// module chunks = 0